import { getUserTimezone } from './get-user-timezone';
import { isValidTimezone } from './is-valid-timezone';

export function resolveDefaultTimezone(savedTimezone?: string): string {
  if (savedTimezone && isValidTimezone(savedTimezone)) {
    return savedTimezone;
  }

  const userTimezone = getUserTimezone();
  return isValidTimezone(userTimezone) ? userTimezone : 'UTC';
}
